GameView = require "views/base/game"
{ DraggyView }  = require("views/components/draggy")
Device = require("lib/device")

class CategoriseView extends GameView
  template: require("./template")
  fitTextOnResize: false
  fitTextOnRender: false

  serialize: ->
    data = super
    maxTextLength = if data.width > 375 then 30 else 20
    data.buttonClass = "btn-long" if data.buttonText?.length > maxTextLength
    updatedAnswers = data.metadata.questions[0].answers.map (a) => {
      id: a.id
      content: a.content or ""
      correct: a.correct
    }
    data.categories = _.shuffle updatedAnswers
    data

  events: ->
    "iostap .btn-done": "endGame"

  show: ->
    super
    delete @index

    @setEl @findOne(".draggy-btn"), "draggyBtn"
    @setEl @findOne(".draggy-parent"), "draggyParent"
    @setEl @findAll(".droppy"), "droppies"
    @setEl @findAll(".droppy-child"), "droppyChild"
    @createDraggy()

    @enterGame()

  createDraggy: ->
    @draggy = new DraggyView
      el: @findOne(".draggy")
      lock: "x"

    @draggy.el.classList.add("no-delay")

    @listenTo @draggy, "drag", @onDrag
    @listenTo @draggy, "drop", @onDrop
    @listenTo this, "resize", @onResize

    @updateDroppyHeight()

  onDrag: (draggy, isInitialDrag) ->
    @index = if draggy.y < 0 then 0 else 1

    for droppy, i in @getEl "droppies"
      droppy.classList.add "no-delay"
      droppy.classList.toggle "active", i is @index

    @transform draggy.el,
      y: draggy.y
      scale: 1.05
      transition: if isInitialDrag then "all 300ms" else "none"

  onDrop: (draggy, isReset) ->
    if isReset
      @transform draggy.el,
        y: draggy.y
        transition: "all 300ms"

    else
      return unless @currentDroppy = @getEl("droppies")[@index]

      @draggy.el.classList.add("draggy-drop")

      @moveDroppies()

      y = (@currentDroppy.offsetHeight - @draggy.offset.height) / 2

      if draggy.y < 0
        y = -y - draggy.offset.height / 2
      else
        y =  y + draggy.offset.height / 2

      draggy.reset x: 0, y: y

    @setState "touched"

  moveDroppies: ->
    y = @draggy.offset.height / 2
    toTransform = [@getEl("droppies")...]

    if Device.breakpoint(["xs", "sm", "md"])
      toTransform.push(@findOne(".slide-title"))

    for el, i in toTransform
      @transform el,
        y: if i is 1 then -y else y
        transition: "all 300ms"

  updateDroppyHeight: ->
    @draggy.getOffset()

    unless @currentState?.refresh
      @el.classList.remove("active")

    el.firstChild.style.height = "" for el, i in @getEl "droppies"

    fontSize = parseInt(window.getComputedStyle(@getEl("droppies")[0]).fontSize)
    height   = _.reduce @getEl("droppies"), (m, el) ->
      if m > el.offsetHeight then m else el.offsetHeight
    , @draggy.el.firstChild.offsetHeight

    for el, i in @getEl "droppies"
      el.firstChild.style.height = "#{height / fontSize}em"

    @draggy.options.minY = -height
    @draggy.options.maxY =  height

    @fitText =>
      window.setTimeout (=> @el.classList.add("active")), 300

  answerDetails: ->
    questions = @options.metadata?.questions or []
    return [] unless questions.length > 0 and @currentDroppy?

    question = questions[0]
    id       = @currentDroppy.dataset.answerId
    answer   = _.findWhere question.answers, { id }
    details  = question: question.question, answer: answer
    [ details ]

  isCorrect: ->
    @currentDroppy?.dataset.correct?

  onRefresh: ->
    if @draggy
      @draggy.el.classList.remove("no-delay")
      for el, i in @getEl "droppies"
        el.classList.remove "no-delay"

    super

  onResize: ->
    @updateDroppyHeight()
    @onDrop(@draggy)

  endGame: ->
    super

    @submit()

module.exports = CategoriseView
